export default __webpack_public_path__ + "static/media/com-citi.bc5d6347.mp4";